var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M12.006 5.268c-.202-.216-.47-.498-.763-.79a6 6 0 1 0-8.486 8.485 72581.7 72581.7 0 0 1 5.25 5.25l2.579 2.58a2 2 0 0 0 2.828 0l7.829-7.83a6 6 0 1 0-8.5-8.472z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }